import { InjectionToken, inject } from '@angular/core';
import { ITenantStore } from './tenant.public';
import { TenantStore } from './tenant.store';

export const TENANT_STORE = new InjectionToken<ITenantStore>('TENANT_STORE', {
    providedIn: 'root',
    factory: () => inject(TenantStore) as ITenantStore,
});
